'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Type = require('./Type');

var _require = require('../helpers'),
    flatten = _require.flatten;

var Param = function () {
  function Param(func, name, defaultValue) {
    var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var types = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Type();
    var description = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

    _classCallCheck(this, Param);

    this.types = types;
    this.name = name;
    this.parent = parent;
    this.optional = !!defaultValue;
    this.defaultValue = defaultValue;
    this.description = description;
    this.props = {};
    this.calls = 0;
    this.func = func;
  }

  /**
   * Parent
   * @param {string} [parent]
   */


  _createClass(Param, [{
    key: 'addProp',
    value: function addProp(key, value) {
      var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.fullName;

      if (!this.props[key]) {
        this.props[key] = Param.create(this.func, key, undefined, parent);
      }
      this.props[key].addExample(value);
    }

    /**
     * Add example
     * @param {Object} example
     * @param {string} [example.type]
     * @param {Object|Object[]} [example.params]
     */

  }, {
    key: 'addExample',
    value: function addExample(example) {
      var _this = this;

      this.calls++;
      if (!example.type) {
        this.optional = true;
        return;
      }

      var type = this.types.addExample(example);

      if (example.type === 'Object') {
        Object.keys(example.params).filter(function (key) {
          return !key.startsWith('_');
        }).forEach(function (key) {
          return _this.addProp(key, example.params[key]);
        });
      }

      if (type.includes('[]')) {
        if (type.startsWith('Object')) {
          var depth = type.match(/\[/g).length;
          var obj = example;
          for (var i = 0; i < depth; i++) {
            obj = obj.params[0];
          }
          var parent = '' + this.fullName + '[]'.repeat(depth);
          Object.keys(obj.params).filter(function (key) {
            return !key.startsWith('_');
          }).forEach(function (key) {
            return _this.addProp(key, obj.params[key], parent);
          });
        }
      }
    }

    /**
     * Check optional
     */

  }, {
    key: 'checkOptional',
    value: function checkOptional() {
      var _this2 = this;

      Object.values(this.props).forEach(function (prop) {
        if (prop.calls < _this2.calls || _this2.optional) {
          prop.optional = true;
        }
      });
    }

    /**
     * To array
     * @returns {string[]}
     */

  }, {
    key: 'toArray',
    value: function toArray() {
      this.checkOptional();
      var name = this.fullName;
      if (this.defaultValue !== undefined) name = name + '=' + this.defaultValue.replace(/'|"/g, '');
      if (this.optional) name = '[' + name + ']';
      var param = ('@param ' + this.types + ' ' + name + ' ' + this.description.trim()).trim();
      var doc = [' * ' + param];

      var subDoc = flatten(Object.values(this.props).map(function (prop) {
        return prop.toArray();
      }));

      if (subDoc.length > 10) {
        return doc;
      }

      return doc.concat(subDoc);
    }
  }, {
    key: 'parent',
    set: function set(parent) {
      this.fullName = parent ? parent + '.' + this.name : this.name;
    }

    /**
     * Create
     * @param {function} func
     * @param {string} name
     * @param {string} [defaultValue]
     * @param {string} [parent]
     * @param {} [types]
     * @param {} [description]
     * @returns {Param}
     */

  }], [{
    key: 'create',
    value: function create(func, name, defaultValue, parent, types, description) {
      var oldParam = func.oldParams[parent + '.' + name] || func.oldParams[name];
      if (oldParam) {
        oldParam.parent = parent;
        return oldParam;
      }
      return new Param(func, name, defaultValue, parent, types, description);
    }

    /**
     * Parse
     * @param {function} func
     * @param {string} string
     * @returns {Param}
     */

  }, {
    key: 'parse',
    value: function parse(func, string) {
      var regex = /@\S+((?: \{.*\})?) (\S+)(.*)/;
      var match = string.match(regex);
      return new Param(func, match[2], undefined, undefined, Type.parse(match[1]), match[3]);
    }
  }]);

  return Param;
}();

module.exports = Param;


//////////////////
// WEBPACK FOOTER
// ../lib/JSDoc/Param.js
// module id = 498
// module chunks = 0